import { render, staticRenderFns } from "./productDiscontinueListing.vue?vue&type=template&id=489f7c00&scoped=true&"
import script from "./productDiscontinueListing.vue?vue&type=script&lang=js&"
export * from "./productDiscontinueListing.vue?vue&type=script&lang=js&"
import style0 from "./productDiscontinueListing.vue?vue&type=style&index=0&id=489f7c00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489f7c00",
  null
  
)

export default component.exports